import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FameBadge from 'components/molecules/Fame/Badge';
import { actionCreators as eventsAC } from 'store/events';

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(eventsAC, dispatch);
};

export default connect<ReturnType<typeof mapDispatchToProps>, any, any /* ownProps */>(
	undefined,
	mapDispatchToProps
)(FameBadge as any);
